import React, {useState} from 'react';
import axios from 'axios';
import EditTask from '../TodoList/Modals/EditTask';
const Card = ({taskObj, index, deleteTask, updateListArray}) => {
    const [modal, setModal] = useState(false);
    const [deleteId, setDeleteId] = useState();

    const colors = [
        {
            primaryColor : "#5D93E1",
            secondaryColor : "#ECF3FC"
        },
        {
            primaryColor : "#F9D288",
            secondaryColor : "#FEFAF1"
        },
        {
            primaryColor : "#5DC250",
            secondaryColor : "#F2FAF1"
        },
        {
            primaryColor : "#F48687",
            secondaryColor : "#FDF1F1"
        },
        {
            primaryColor : "#B964F7",
            secondaryColor : "#F3F0FD"
        }
    ]

    const toggle = () => {
        setModal(!modal);
    }

    const updateTask = (obj) => {
          toggle()
          updateListArray(obj, index)
    }

    const handleDelete = (e) => {
        e.preventDefault();
        const url = '/api/TaskList/';
        axios.delete(url + deleteId)
        .then((res) => {
            deleteTask(index)     
        //    console.log(res.data);       
        })
        .catch(error => {
          console.log(error);
        })
        deleteTask(index)      
    }

    return (
        <div className = "card-wrapper mr-3">
            <div style={{margin: "0px",fontSize:"10px", textAlign:'right'}}>{taskObj.t_등록일자} Id:{taskObj.id}</div>
            <div className = "card-top" style={{"backgroundColor": colors[index%5].primaryColor}}></div>
            <div className = "task-holder">
                <span className = "card-header" style={{"backgroundColor": colors[index%5].secondaryColor, "borderRadius": "10px"}}>{taskObj.t_할일제목}</span>
                <pre style={{whiteSpace: 'pre-wrap'}} className = "mt-3">{taskObj.t_할일내용}</pre>

                <div style={{"position": "absolute", "right" : "20px", "bottom" : "5px"}}>
                    <i className = "far fa-edit mr-3" style={{"color" : colors[index%5].primaryColor, "cursor" : "pointer"}} onClick = {() => setModal(true)}></i>
                    <i className="fas fa-trash-alt" style = {{"color" : colors[index%5].primaryColor, "cursor" : "pointer"}} onClick = {handleDelete} onMouseMove={() => setDeleteId(taskObj.id) }></i>
                </div>
        </div>
        <EditTask modal = {modal} toggle = {toggle} updateTask = {updateTask} taskObj = {taskObj}/>
        </div>
    );
};

export default Card;